import {IczTableDataSource} from '@icz/angular-table';
import {CirculationSearchService, ExtendedCirculationActivityDto} from '|shared';

export class DocumentDetailActivitiesDatasource extends IczTableDataSource<ExtendedCirculationActivityDto> {

  constructor(
    searchService: CirculationSearchService,
    documentId: number,
  ) {
    super(searchParams => searchService.findActivitiesForDocument(searchParams, documentId));
  }

}
